import ReportsUnitDetail from './container'
export default ReportsUnitDetail
